import { FC } from 'react';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import { Typography } from 'antd';
import Block from './Block';
import Card from './Card';
import V2Table from '@/common/components/Data/V2Table';

/**
 * 分析完成结果-进店率
 * @description
 * @demo
 */
const Component:FC<{}> = () => {

  /* state */

  const defaultColumns: any[] = [
    {
      title: '门店', key: 'name', width: '124px',
      render: (val, record) => <Typography.Text
        ellipsis={{ tooltip: { color: '#2F3336', overlayInnerStyle: { color: '#fff' } } }}
        className={cs({ [styles.highlight]: record.highlight })}
        style={{ width: '124px' }}
      >{val}</Typography.Text>
    },
    {
      title: '过店人数', key: 'throughNum', width: '65px', align: 'right',
      render: (val, record) => <Typography.Text className={cs({ [styles.highlight]: record.highlight })}>{val}</Typography.Text>
    },
    {
      title: '进店人数', key: 'entryNum', width: '65px', align: 'right',
      render: (val, record) => <Typography.Text className={cs({ [styles.highlight]: record.highlight })}>{val}</Typography.Text>
    },
    {
      title: '进店率', key: 'entryRate', width: '55px', align: 'right',
      render: (val, record) => <Typography.Text className={cs({ [styles.highlight]: record.highlight })}>{val}</Typography.Text>
    },
  ];

  const descriptions = [
    { title: '位置条件', value: '该位置临近大悦城，地理位置偏优，该商场工作日日均客流：6.9万人次，节假日日均客流：12.4万人次' },
    { title: '过店客流', value: '晚高峰（18:00～19:00）进店客流比较高；与样本门店客流趋势接近' },
    { title: '业态占比', value: '业态分布主要聚集在餐饮、购物类门店，周边500m以及1.0km覆盖客群占比最高，建议选址开店在该范围商圈内' },
    { title: '客流特征', value: '商圈围栏500米内客流画像中女性比例较多为55.8%，18至24岁年龄段占比最高为20.4％；门店踩点客群女性占比高' },
    { title: '竞争环境', value: '点位同类门店数量≤3家，最近竞品距离为800m，竞争系数为3.7%' },
    { title: '交通便利性', value: '交通便利性评分较高，建议在门店招牌和指引标识上加强投入' },
  ];

  /* hooks */

  /* methods */
  const methods = useMethods({

    async loadData() {
      const data: any[] = [
        { name: '本门店(预测)', throughNum: '3731(日均)', entryNum: '189', entryRate: '5.5%', highlight: true },
        { name: '正新鸡排(佳和小区店)', throughNum: '4512', entryNum: '261', entryRate: '5.8%' },
        { name: '正新鸡排(武汉仓埠店)', throughNum: '5823', entryNum: '302', entryRate: '5.2%' },
        { name: '正新鸡排(南渡店)', throughNum: '6215', entryNum: '304', entryRate: '4.9%' },
        { name: '正新鸡排(南通久辉店)', throughNum: '1434', entryNum: '250', entryRate: '6.1%' },
        { name: '正新鸡排(人民南路店)', throughNum: '7241', entryNum: '324', entryRate: '4.5%' },
        { name: '正新鸡排(哈尔滨乐松)', throughNum: '5309', entryNum: '297', entryRate: '5.6%' },
        { name: '正新鸡排(三江公园店)', throughNum: '4927', entryNum: '298', entryRate: '5.9%' },
      ].map((item, index) => ({ ...item, key: index }));

      return {
        dataSource: data,
        count: data.length,
      };
    },

  });

  return (<Block className={styles.entryRate}>
    <div className={styles.top}>
      <Card title='门店进店率分析' className={styles.entryRateChart}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/entry_rate_chart.png`} className={styles.chart} />
      </Card>
      <Card title='相似门店进店率对比' className={styles.entryRateTable}>
        <V2Table
          rowKey='key'
          filter={{}}
          onFetch={methods.loadData}
          defaultColumns={defaultColumns}
          hideColumnPlaceholder
          pagination={false}
          floorWidth={50}
          className={cs(styles.table, styles.darkTable)}
        />
      </Card>
    </div>

    {Array.isArray(descriptions) && !!descriptions.length && <div className={styles.descriptions}>
      {descriptions.map((item, index) => (
        <div key={index} className={styles.item}>
          <div className={styles.titleWrapper}>
            <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/entry_rate_checkbox_select.png`} className={styles.icon}/>
            <div className={styles.title}>{item.title}</div>
          </div>
          <div className={styles.value}>{item.value}</div>
        </div>
      ))}
    </div>}

  </Block>);
};

export default Component;
